import { all, fork } from 'redux-saga/effects';

import { userSaga } from './user/saga';
import { companySaga } from './company/saga';
import { authSaga } from './auth/saga';
import { settingsSaga } from './settings/saga';
import { wcoxmlwebSaga } from './wcoxmlweb/saga';

export function* rootSaga() {
  yield all([fork(userSaga), fork(companySaga), fork(authSaga), fork(settingsSaga), fork(wcoxmlwebSaga)]);
}
